var exports = {
  "Qs": "xaf9ae18d--c5e0d5--content",
  "Kk": "xaf9ae18d--c5e0d5--icon",
  "XI": "xaf9ae18d--c5e0d5--action",
};

module.exports = exports;
